module.exports = "pegasus_template/assets/themelp1/ebook/109.png";